<template>
  <div class="device">
    <div class="">
      {{ $t("point.device") }}
      <em class="fas fa-edit edit" size="mini" @click="showEditForm()" v-show="!editing"></em>
    </div>
    <div class="body" v-loading="loading">
      <center class="info" v-if="!point.device && !editing">
        {{ $t("point.noDeviceFound") }}
      </center>
      <ul v-if="point.device && !editing">
        <li>
          <span style="font-size: 10px; color: rgb(128, 128, 128)">{{
              $t("common.macAddress")
          }}</span>
          <br />
          <span>{{ point.device.macAddress }}</span>
          <br />
          <br />
          <div v-if="point.device && point.device.macAddress">
          <em v-show="point.device.macAddress == deviceBattery.macAddress" class="color-circle" v-bind:style="{
            'background-color': batterySeverity(deviceBattery.batteryLevel)
              .color,
          }" slot="reference"></em><span style="margin-left: 5px"
            v-show="point.device.macAddress == deviceBattery.macAddress">
            {{ deviceBattery.batteryLevel }} V
            {{ batterySeverity(deviceBattery.batteryLevel).severity }}
          </span>
          <br />
          <span v-show="point.device.macAddress == deviceBattery.macAddress">{{
              toDisplayDate(deviceBattery.batteryLevelDate)
          }}</span>
          </div>
        </li>
        <li v-show="false">
          <span style="font-size: 10px; color: rgb(128, 128, 128)">{{
              $t("gateway.gatewayName")
          }}</span>
          <br />
          <span>{{ point.device.gateway }}</span>
        </li>
      </ul>
      <el-form v-if="editing" label-position="top" label-width="100px" :model="form" ref="form" :rules="rules">
        <el-form-item prop="macAddress">
          <slot name="label">
            {{ $t("common.macAddress") }}
            <el-tooltip :content="$t('point.macAddressInfo')" placement="top">
              <em class="el-icon-info"></em>
            </el-tooltip>
          </slot>
          <br />
          <el-select filterable clearable v-model="form.macAddress" :loading="deviceLoading"
            :placeholder="$t('point.typeForSearchDevice')">
            <el-option v-for="item in devices" :key="item.macAddress" :label="item.macAddress" :value="item.macAddress">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Gateway" prop="gateway" v-show="false">
          <el-select v-model="form.gateway" :loading="gwLoading" placeholder="Select">
            <el-option v-for="item in gateways" :key="item.value" :label="item.label" :value="item.macAddress">
            </el-option>
          </el-select>
          <el-button size="mini" type="primary" class="refreshButton" icon="el-icon-refresh" @click="getGateways()">
          </el-button>
        </el-form-item>
        <el-form-item></el-form-item>
        <el-button v-if="checkPermission('updatePointConfig')" size="mini" @click="save()">{{ $t("point.save") }}
        </el-button>
        <el-button size="mini" @click="editing = false">{{
            $t("point.cancel")
        }}</el-button>
        <el-button v-if="checkPermission('deletePointConfig') && point.device" size="mini" style="float: right"
          type="danger" @click="deleteIt()">{{ $t("common.delete") }}</el-button>
      </el-form>
    </div>
    <br />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { colorLib } from "../util";
import dayjs from "dayjs";
import preferences from "../util/preferences";
export default {
  name: "Device",
  props: ["point"],
  data() {
    let IsMacAddress = (rule, value, callback) => {
      if (
        !/^[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}$/g.test(
          value
        )
      ) {
        return callback(
          new Error("Please input proper mac address (ex: AB:CD:EF:12:34:56)")
        );
      }
      return callback();
    };
    return {
      hexTokens: {
        F: {
          pattern: /[0-9a-fA-F]/,
          transform: (v) => v.toLocaleUpperCase(),
        },
      },
      showEditDevice: false,
      bodyStyle: {
        padding: "5px",
      },
      loading: false,
      form: {
        macAddress: "",
        gateway: "",
      },
      editing: false,
      rules: {
        macAddress: [
          {
            validator: IsMacAddress,
            trigger: "blur",
          },
        ],
        // gateway: [
        //   {
        //     required: true,
        //     message: this.$t("point.inputGateway"),
        //     trigger: "blur",
        //   },
        // ],
      },
    };
  },
  computed: {
    ...mapState("gateway", ["gateways"]),
    ...mapState("device", ["deviceLoading", "devices", "deviceBattery"]),
    gwLoading() {
      return this.$store.state.gateway.loading;
    },
  },
  methods: {
    ...mapActions("point", ["updateDevice", "deleteDevice"]),
    ...mapActions("device", ["getAllDevices"]),
    toDisplayDate(timestamp) {
      return dayjs(timestamp).format(preferences().localization.dateFormat);
    },
    batterySeverity(value) {
      if (value < 3.1) {
        return {
          severity: this.$t("alarms.level3"),
          color: colorLib.getAlarmColorByOrder(3),
        };
      } else if (3.1 < value && value < 3.2) {
        return {
          severity: this.$t("alarms.level2"),
          color: colorLib.getAlarmColorByOrder(2),
        };
      } else if (3.2 < value && value < 3.4) {
        return {
          severity: this.$t("alarms.level1"),
          color: colorLib.getAlarmColorByOrder(1),
        };
      } else {
        return {
          severity: this.$t("point.good"),
          color: colorLib.getAlarmColorByOrder(0),
        };
      }
    },
    sanitize(value) {
      this.form.macAddress = value.trim().toUpperCase();
    },
    deleteIt() {
      this.loading = true;
      this.$confirm(this.$t("point.areYouSure?"), this.$t("point.warning"), {
        confirmButtonText: this.$t("point.ok"),
        cancelButtonText: this.$t("point.cancel"),
        type: "warning",
      })
        .then(() => this.deleteDevice(this.point._id))
        .then(() => {
          this.loading = false;
          this.editing = false;
          this.$message({
            type: "success",
            message: this.$t("point.DeleteCompleted"),
          });
        })
        .finally(() => (this.loading = false));
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.updateDevice({
            pointId: this.point._id,
            macAddress: this.form.macAddress,
            gateway: this.form.gateway,
            channelGroups: this.form.channelGroups
          })
            .then(() => {
              this.editing = false;
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    showEditForm() {
      this.getAllDevices();
      if (this.point.device) {
        this.form = {
          macAddress: this.point.device.macAddress,
          gateway: this.point.device.gateway,
        };
      } else {
        this.form = {
          macAddress: "",
          gateway: "",
        };
      }
      this.editing = true;
    },
  },
};
</script>
<style>
.color-circle {
  height: 20px;
  width: 20px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
}

.device .el-form--label-top .el-form-item__label {
  padding-bottom: 0px;
}

.device .el-form-item__label {
  line-height: 0px;
  font-size: 12px;
}

.device .el-form-item {
  margin-bottom: 18px;
}

.info {
  padding: 10px;
  color: #232323;
  font-style: italic;
  font-size: 10px;
}
</style>
<style  scoped>
.device .header:hover .edit,
.el-card__header:hover .edit {
  opacity: 1;
}

.edit {
  display: inline-block;
  opacity: 0.5;
}

.device {
  padding: 10px;
}

.device .body li {
  list-style-type: none;
  margin-bottom: 10px;
}

.device .header {
  font-size: 14px;
  padding-bottom: 5px;
  border-bottom: 1px solid rgb(226, 226, 226);
}

.path {
  margin-left: 5px;
  line-height: -20px;
  font-size: 12px;
  color: gray;
}

.name {
  font-size: 20px;
  font-weight: bold;
}
</style>